var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLargeAnimals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000113326174887785188760000001495446735124638908_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 7.7,
    y: 7.7,
    width: 87.5,
    height: 87.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013159008319079256030000012872497623829177533_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013159008319079256030000012872497623829177533_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5,21.6H81.9c1.5-2,2.3-4.5,2.3-7v-1.4c0-1.4-1.1-2.6-2.6-2.6c-1.4,0-2.6,1.1-2.6,2.6v1.4c0,3.9-3.1,7-7,7 c-3.9,0-7-3.2-7-7v-1.4c0-1.4-1.1-2.6-2.6-2.6c-1.4,0-2.6,1.1-2.6,2.6v1.4c0,2.6,0.8,5,2.3,7H51.3c-1.4,0-2.6,1.1-2.6,2.6v2.7 c0,4.5,3.7,8.1,8.1,8.1h1.8c-2.8,2-6.1,3.1-9.5,3.1H30.7c-3.1,0-6.1,1-8.6,2.8C14,41.1,7.6,47.7,7.6,55.8v12.4 c0,1.4,1.1,2.6,2.6,2.6c1.4,0,2.6-1.1,2.6-2.6V55.8c0-1.2,0.2-5.1,4-7.9c-0.6,1.6-0.9,3.4-0.9,5.2v9.8c0,3.8,0.6,7.5,1.8,11.2 l1,3.1l2.7,13.6c0.2,1.2,1.3,2.1,2.5,2.1h8.2c1.4,0,2.6-1.1,2.6-2.6V78.9h21v11.2c0,1.4,1.1,2.6,2.6,2.6h9.6 c1.4,0,2.6-1.1,2.6-2.6V77.7c5.2-4,8.2-10.1,8.2-16.7v-9.5h0.2c4.5,0,8.1-3.7,8.1-8.1v-2.7c0-2.1-0.8-4.2-2.3-5.7H87 c4.4,0,8.1-3.6,8.1-8.1v-2.7C95.1,22.8,93.9,21.6,92.5,21.6z M64.9,32.4v-5.7H79v5.9c-0.1,0-0.1,0-0.2,0H65.1c-0.1,0-0.1,0-0.2,0 V32.4L64.9,32.4z M54.7,29c-0.6-0.6-0.9-1.3-0.9-2.1v-0.2h5.9v3.1h-2.9C56,29.9,55.3,29.6,54.7,29z M45.7,43.2 c-1.2,4.9-5.6,8.6-10.9,8.6c-1.4,0-2.6,1.1-2.6,2.6c0,4.6-3.8,8.4-8.4,8.4h-2.9V53c0-5.4,4.4-9.8,9.8-9.8H45.7z M73.5,61 c0,5.3-2.7,10.3-7.1,13.3c-0.7,0.5-1.1,1.3-1.1,2.1v11.2h-4.5V76.4c0-1.4-1.1-2.6-2.6-2.6H32.1c-1.4,0-2.6,1.1-2.6,2.6v11.2H26 l-2.3-11.7c0-0.1,0-0.2-0.1-0.3l-1.1-3.2c-0.5-1.4-0.8-2.9-1.1-4.4h2.5c6.7,0,12.2-4.8,13.3-11.2c7.1-1,12.7-6.6,13.8-13.6 c2.1-0.2,4.1-0.7,6-1.4v1.7c0,4.4,3.6,8.1,8.1,8.1h8.4V61z M81.7,43.4c0,1.6-1.3,2.9-2.9,2.9H65.1c-1.6,0-2.9-1.3-2.9-2.9v-2.7 c0-1.6,1.3-2.9,2.9-2.9h13.7c1.6,0,2.9,1.3,2.9,2.9V43.4z M90,26.9c0,0.8-0.3,1.5-0.9,2.1c-0.6,0.6-1.3,0.9-2.1,0.9h-2.9v-3.1H90 V26.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeAnimals);
export default __webpack_public_path__ + "static/media/largeAnimals.09e2377a37c7123154130fe1b833a877.svg";
export { ForwardRef as ReactComponent };